<template>
    <div>
        <div class="panel-tag mt-2">
            {{__t("GLOVO_LOCATION_PARAMS")}}
        </div>

        <div class="glovo_location_auth" >
            <b-overlay :show="is_load_connect">
                <div class="form-group mt-2">
                    <label class="form-label" for="glovo_username">
                        {{__t("GLOVO_USERNAME")}}
                    </label>

                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
                        <span class="input-group-text">
                            <i class="fal  fa-typewriter fs-xl" ></i>
                        </span>
                        </div>
                        <input id="glovo_username" type="text" class="form-control" v-model="general_fields.username">
                    </div>
                </div>

                <div class="form-group mt-2">
                    <label class="form-label" for="glovo_password">
                        {{__t("GLOVO_PASSWORD")}}
                    </label>

                    <div class="input-group flex-nowrap">
                        <div class="input-group-prepend">
                            <span class="input-group-text">
                                <i class="fal  fa-typewriter fs-xl" ></i>
                            </span>
                        </div>
                        <input id="glovo_password" type="text" class="form-control" v-model="general_fields.password">
                    </div>
                </div>

                <button type="button" v-on:click="get_locations" class="btn btn-outline-success  waves-effect waves-themed">
                    {{__t("CONNECT")}}
                </button>
            </b-overlay>
        </div>

        <div class="form-group mt-4 pt-4 mb-4 pb-4">
            <b-overlay :show="is_load">
                <label class="form-label" for="glovo_location">
                    {{__t("GLOVO_REST")}}*
                </label>

                <div class="" v-if="ext_restaurants.length > 0">
                    <v-select
                        v-model="general_fields.store_id"
                        class="imc_reasons"
                        :reduce="item => String(item.provider_id)"
                        label="provider_name"
                        :filter="searchRest"
                        :options="this.ext_restaurants"
                    >
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                <div>
                                    {{option.provider_id}} - {{ option.provider_name }}
                                </div>
                            </div>
                        </template>
                    </v-select>
                </div>
            </b-overlay>
        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select';

export default {
    name: "bolt_review_params",
    props : {
        location : {
            type : Object
        }
    },

    data() {
        return {
            ext_restaurants : [],
            auth_ext : [],
            is_load : false,
            is_load_connect : false,
            has_own : false,
        }
    },

    components : {
        vSelect
    },

    mounted() {
        this.check_if_exist();
    },

    methods : {

        check_if_exist() {
            if(this.general_fields.hasOwnProperty("id")) {
                if(parseInt(this.general_fields.id) > 0) {
                    this.get_locations();
                }
            }
        },

        searchRest(options, search) {
            const fuse = new Fuse(options, {
                keys: [ 'provider_id','provider_name'],
                shouldSort: true,
            })
            return search.length
                ? fuse.search(search).map(({ item }) => item)
                : fuse.list
        },

        async get_locations() {
            this.ext_restaurants = [];
            this.is_load_connect = true;
            await review_api.post('/reviews/sources/62/ext_locations',{
                "username" : this.general_fields.username,
                "password" : this.general_fields.password
            }).then(({data}) => {
                if (data.status === "operation_success") {
                    this.ext_restaurants = data.data;
                }
                this.is_load_connect = false;
            }).catch(({response}) => {
                this.is_load_connect = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },
    },

    computed : {
        general_fields() {
            if (this.location.hasOwnProperty("general_fields")) {
                return this.location.general_fields;
            }

            return {
                "id" : 0,
                "username" : "",
                "password" : "",
                "store_id" : null,
            }
        }
    }
}
</script>



<style scoped>

</style>
